module.exports = __webpack_public_path__ + "static/media/hero-1.0a7ff58f.jpg";